import { Action, combineReducers } from "redux";

import { ActionType } from "../action-types";
import attachmentsReducer, { AttachmentsState } from "./attachmentsReducer";
import convoReducer, { ReduxConversation } from "./convoReducer";
import sidReducer from "./currentConvoReducer";
import lastReadIndexReducer from "./lastReadIndexReducer";
import loadingReducer from "./loadingReducer";
import messageReducer, { ChatMessagesState } from "./messageListReducer";
import notificationsReducer, {
  NotificationsType,
} from "./notificationsReducer";
import participantReducer, { ParticipantsType } from "./participantsReducer";
import templateReducer, { ReduxTemplate } from "./msgTemplatesReducer";
import tokenReducer from "./tokenReducer";
import typingDataReducer, { TypingDataState } from "./typingDataReducer";
import unreadMessagesReducer, {
  UnreadMessagesState,
} from "./unreadMessagesReducer";

export type AppState = {
  token: string;
  convos: ReduxConversation[];
  sid: string;
  messages: ChatMessagesState;
  unreadMessages: UnreadMessagesState;
  loadingStatus: boolean;
  participants: ParticipantsType;
  attachments: AttachmentsState;
  typingData: TypingDataState;
  lastReadIndex: number;
  notifications: NotificationsType;
  templates: ReduxTemplate[];
};

export const initialState = {
  token: "",
  sid: "",
  messages: {},
  attachments: {},
  participants: {},
  convos: [],
  unreadMessages: {},
  loadingStatus: true,
  typingData: {},
  lastReadIndex: -1,
  notifications: [],
  templates: [],
};

const reducers = (
  state: AppState | undefined,
  action: Action
): ReturnType<typeof appReducer> => {
  if (action.type === ActionType.LOGOUT) {
    localStorage.removeItem("username");
    localStorage.removeItem("password");
    return appReducer(initialState, action);
  }

  return appReducer(state, action);
};

const appReducer = combineReducers({
  token: tokenReducer,
  convos: convoReducer,
  sid: sidReducer,
  lastReadIndex: lastReadIndexReducer,
  messages: messageReducer,
  loadingStatus: loadingReducer,
  participants: participantReducer,
  unreadMessages: unreadMessagesReducer,
  attachments: attachmentsReducer,
  typingData: typingDataReducer,
  notifications: notificationsReducer,
  templates: templateReducer,
});

export default reducers;
